import momenJalaali from "moment-jalali";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker2";
import { Button, Card, Row } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import BihamtaTable from "../../Components/BihamtaTable";
import { setDialog } from "../../store/api/GetAllProduct";
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import { exportToExcel,  keyIsLetterOrNumber, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Printer, Search } from "react-bootstrap-icons";
import { searchDisassembly, deleteDisassembly } from "../store/api/DisassemblyAPI";
import { getSystemSettings } from "../../Sale/store/api/Invoice";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBroom, faSearch } from '@fortawesome/free-solid-svg-icons';

const SearchDisassembly = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const filterData = useSelector(state => state.ProductionReducer.disassemblySearchFilters)
    const [dateFilters, setDateFilters] = useState({
        CreationDate: filterData?.CreationDate,
        CreationDateTo: filterData?.CreationDateTo,
    });
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const [createBy, setCreateBy] = useState(null);
    const [showFilter, setShowFilter] = useState(true);
    const [destStorage, setDestStorage] = useState(null);
    const [popUser, setPopUser] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const [sourceStorage, setSourceStorage] = useState(null);
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel"];
    let productGrouppingType = 1;
    let pDefaultSalePrice = "";
    let pDefaultSalePriceLabel = "";
    if (Array.isArray(systemSettings)) {
        productGrouppingType = Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1);
        pDefaultSalePrice = systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue ?? "";
        pDefaultSalePriceLabel = systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue ?? "";
    }

    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "شماره فرم", colName: "DisassemblyNumber", showInMobile: true },
        { colTitle: "تاریخ فرم", colName: "PCreationDate", showInMobile: true },
        { colTitle: "مارک کالا", colName: "MasterProductModel", showInMobile: false },
        { colTitle: "نوع کالا", colName: "MasterProductName" },
        { colTitle: "مدل کالا", colName: "MasterProductModel" },
        { colTitle: "سریال کالا", colName: "MasterProductSerial" },
        { colTitle: "توضیحات", colName: "Description", colType: "string", maxTextLength: 50 }
    ]
    const tableRowButtons = [
        { title: "نمایش فرم", type: "show", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobile },
        {
            title: "چاپ فرم", type: "common", className: "group-Btn-smalll btn-primary", onclick: print, icon: <Printer color="#2727ff" size={18} className="rowBtn" />
        },
        {
            title: "حذف فرم", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف فرم',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteDisassembly(item.ID, onDelete)
                }))
            }
        }

    ]
    function onDelete(res) {
        if (res.Error) {
            setErrorDialog(dispatch, res.Error, "حذف دمونتاژ");
        }
        else if (res !== "PENDING") {
            dispatch(searchDisassembly(filterData));
        }
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        filterData.ProductID = null;
        filterData.ProductName = null;
        filterData.ProductHolder = null;
        const setData = (data) => {
            selectProduct(data);
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, forStorageReport: true });
    }
    function showModalStorage(e, fieldName) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        if (fieldName === "DestStorage") {
            filterData.DestinationStorageID = null;
            filterData.DestinationStorageName = null;
        }
        else {
            filterData.SourceStorageID = null;
            filterData.SourceStorageName = null;
        }
        const onSelectStorage = (data) => {
            if (fieldName === "DestStorage") {
                setDestStorage(data);
            }
            else {
                setSourceStorage(data)
            }
        }
        setPopStorage({ show: true, setStorageData: onSelectStorage })
    }
    function showCreateBy() {
        filterData.CreateById = null;
        filterData.CreateByName = null;
        setPopUser({ show: true, selectUserWithName: setCreateBy });
    }

    function search(data) {
        let creationDate = document.getElementsByName("CreationDate")[0].value;
        let creationDateTo = document.getElementsByName("CreationDateTo")[0].value;
        if (creationDate !== '') {
            data.CreationDate = dateFilters.CreationDate;
        }
        if (creationDateTo !== '') {
            data.CreationDateTo = dateFilters.CreationDateTo;
        }
        data.Take = 10;
        data.Skip = 0;
        dispatch(searchDisassembly(data));
    }
    function print(item) {
        history.push({
            pathname: `/PrintViewer/Disassembly/false`,
            state: {
                dataUrl: `api/DisassemblyAPI/GetDisassembly?id=${item.ID}`,
                method: "get"
            }
        });
    }
    function rowClick(item) {
        if (item.ctrlIsDown) {
            window.open(`/Production/Disassembly/${item.ID}`);
        }
        else {
            history.push(`/Production/Disassembly/${item.ID}`)
        }
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({
            CreationDate: null,
            CreationDateTo: null,
        });
        setCreateBy(null);
        setDestStorage(null);
        setSourceStorage(null);
        selectProduct(null);
        dispatch(searchDisassembly({ Take: 10, Skip: 0 }));
    }
    function toExcel() {
        const url = "api/DisassemblyAPI/SearchDisassembly";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("SearchDisassmebly", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-تولید";
        dispatch(getSystemSettings(settingNames));
    }, []);
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;جستجوی دمونتاژ
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType} defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} />
                    <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <div className="col-md-2 form-group">
                                <label>شماره فرم از:</label>
                                <input type="text" className="form-control" name="DisassemblyNumber" ref={register({})} defaultValue={filterData?.DisassemblyNumber ?? ""} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>شماره فرم تا:</label>
                                <input type="text" className="form-control" name="DisassemblyNumberTo" ref={register({})} defaultValue={filterData?.DisassemblyNumberTo ?? ""} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>انبار مبدا:</label>
                                <input type="hidden" name="SourceStorageID" value={sourceStorage?.StorageID ?? filterData?.SourceStorageID ?? ""} ref={register({})} />
                                <input type="text" className="form-control" readOnly onKeyDown={e => showModalStorage(e, "SourceStorage")} name="SourceStorageName" ref={register({})}
                                    value={sourceStorage?.StorageName ?? filterData?.SourceStorageName ?? ""} />
                                <Button className="btn-input-tiny" onClick={e => showModalStorage(e, "SourceStorage")} style={{ top: 25 }}><List size={23} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>انبار مقصد:</label>
                                <input type="hidden" name="DestinationStorageID" value={destStorage?.StorageID ?? filterData?.DestinationStorageID ?? ""} ref={register({})} />
                                <input type="text" className="form-control" readOnly onKeyDown={e => showModalStorage(e, "DestStorage")} ref={register({})} name="DestinationStorageName"
                                    value={destStorage?.StorageName ?? filterData?.DestinationStorageName ?? ""} />
                                <Button className="btn-input-tiny" onClick={e => showModalStorage(e, "DestStorage")} style={{ top: 25 }}><List size={23} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>کالا:</label>
                                <input type="hidden" name="ProductID" value={selectedProduct?.ProductID ?? filterData?.ProductID ?? ""} readOnly ref={register({})} />
                                <input type="text" className="form-control" readOnly onKeyDown={showModalProduct} name="ProductName" ref={register({})}
                                    value={selectedProduct?.ProductName ?
                                        (selectedProduct?.HolderName + "-" + selectedProduct?.ProductName + "-" + selectedProduct.ProductModel) : filterData?.ProductName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showModalProduct} style={{ top: 25 }}><List size={23} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>ثبت کننده:</label>
                                <input type="hidden" name="CreateById" value={createBy?.ID ?? filterData?.CreateById ?? ""} ref={register({})} />
                                <input type="text" className="form-control" readOnly onKeyDown={showCreateBy} name="CreateByName" ref={register({})}
                                    value={createBy?.Name ?? filterData?.CreateByName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showCreateBy} style={{ top: 25 }}><List size={23} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>سریال کالا:</label>
                                <input type="text" className="form-control" name="ProductSerial" ref={register({})} defaultValue={filterData?.ProductSerial ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>تاریخ ثبت از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="CreationDate"
                                    value={dateFilters.CreationDate ? momenJalaali(dateFilters.CreationDate) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, CreationDate: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>تاریخ ثبت تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="CreationDateTo"
                                    value={dateFilters.CreationDateTo ? momenJalaali(dateFilters.CreationDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, CreationDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>توضیحات:</label>
                                <input type="text" className="form-control" name="Description" ref={register({})} defaultValue={filterData?.Description ?? ""} />
                            </div>
                        </Row>
                        <Button type="submit" variant="secondary" className="group-Btn-large mt-2"><Search size={15} />&nbsp;جستجوی دمونتاژ</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable hasPaging={true} columns={tableColes} rowButtons={tableRowButtons} filterData={filterData} searchMethod={(data) => dispatch(searchDisassembly(data))}
                        reducerName="ProductionReducer" objectName="disassemblySearchList" rowClick={rowClick} style={{ whiteSpace: "nowrap" }} className="mt-1" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default SearchDisassembly;